/**
 * Pool ID, client ID and API URL are public identifiers and ship in the bundle
 * by design (SPEC §9). Nothing else does.
 */
function required(name: string, value: string | undefined): string {
  if (value == null || value === "" || value.includes("<")) {
    throw new Error(
      `${name} is not configured. Locally: copy .env.example to .env and fill it in. ` +
        "On Cloudflare Pages: set it under Settings → Environment variables and redeploy — " +
        "these are baked in at build time.",
    );
  }
  return value.replace(/\/+$/, "");
}

export const appConfig = {
  apiUrl: required("VITE_API_URL", import.meta.env.VITE_API_URL),
  authority: required("VITE_COGNITO_AUTHORITY", import.meta.env.VITE_COGNITO_AUTHORITY),
  clientId: required("VITE_COGNITO_CLIENT_ID", import.meta.env.VITE_COGNITO_CLIENT_ID),
  cognitoDomain: required("VITE_COGNITO_DOMAIN", import.meta.env.VITE_COGNITO_DOMAIN),
  redirectUri: `${window.location.origin}/`,
};
